module.exports = __webpack_public_path__ + "static/media/close-black.40d96c15.svg";